import { Font } from '@react-pdf/renderer';

/** @type {import('@react-pdf/types').SingleLoad} */
const font = {
  family: 'Gothic',
  fontWeight: 400,
  format: 'truetype',
  src: `//res.cloudinary.com/bottlebooks/raw/upload/v1658764260/pdf-objects/ABSWineAgencies/GOTHIC.TTF`,
};

Font.register(font);

const style = { fontFamily: font.family, fontWeight: Number(font.fontWeight) };
export default style;
